export default __webpack_public_path__ + "static/media/Etherfish2.30bd2862.gif";